import React from 'react';
import { Box, Text } from '@wix/design-system';
import s from './ProductHat.scss';
const hatContainerDefaults = {
    width: '100%',
    background: 'linear-gradient(90deg, #A429FA 0%, #3F00A5 100%)',
};
const hatTextDefaults = {
    weight: 'bold',
    light: true,
};
function ProductHatComponent({ hatText, dataHook, className, width, background, textWhite, textWeight, height, }) {
    return (React.createElement(Box, { dataHook: dataHook, align: "center", verticalAlign: "middle", width: width ?? hatContainerDefaults.width, background: background ?? hatContainerDefaults.background, height: height, className: className }, typeof hatText === 'string' ? (React.createElement(Text, { light: textWhite ?? hatTextDefaults.light, weight: textWeight ?? hatTextDefaults.weight, className: s.hatText }, hatText)) : (hatText)));
}
export const ProductHat = React.memo(ProductHatComponent);
//# sourceMappingURL=ProductHat.js.map